module.exports = __webpack_public_path__ + "img/produk-placeholder-2.44370005.webp";